import { BasketballGameCarInformation, BasketballTeamGame } from '@hefe/models';
import { useAppDispatch } from '../../../../../store/store';
import React, { useEffect, useState } from 'react';
import { CarsSlice } from '@hefe/store';
import { Descriptions, Space, Spin, Typography } from 'antd';
import { t } from 'i18next';
import { formatDateTime } from '@hefe/utils';
import { useSelector } from 'react-redux';

interface GameDetailsTeamCarsInformationComponentProps {
  teamDetails: BasketballTeamGame;
}

export default function GameDetailsTeamCarsInformationComponent(
  props: GameDetailsTeamCarsInformationComponentProps
) {
  const { teamDetails } = props;

  const dispatch = useAppDispatch();
  const carsInformation = useSelector(
    CarsSlice.basketballGameCarsInformationSelector
  );

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCarsInformation();
  }, []);

  const fetchCarsInformation = () => {
    setLoading(true);
    dispatch(
      CarsSlice.fetchBasketballGameCarsInformation({
        gameId: props.teamDetails.game_id,
        teamId: props.teamDetails.team_id,
        cacheDuration: 5 * 60 * 1000,
      })
    )
      .unwrap()
      .catch(() => undefined)
      .finally(() => setLoading(false));
  };

  const carData = (car: BasketballGameCarInformation) => {
    return (
      <Descriptions column={1} bordered>
        <Descriptions.Item label={t('manufacturer')}>
          {car.manufacturer}
        </Descriptions.Item>
        <Descriptions.Item label={t('model')}>{car.model}</Descriptions.Item>
        <Descriptions.Item label={t('cars.licence_plate')}>
          {car.licence_plate}
        </Descriptions.Item>
        <Descriptions.Item label={t('seats')}>{car.seats}</Descriptions.Item>
        <Descriptions.Item label={t('cars.fuel')}>{car.fuel}</Descriptions.Item>
        {car?.relevant_reservations?.length > 0 && (
          <Descriptions.Item label={t('cars.reservations.more')}>
            {car.relevant_reservations.map((reservation) => (
              <Space
                key={reservation.id}
                direction="vertical"
                size={0}
                style={{
                  textDecoration: reservation.canceled
                    ? 'line-through'
                    : 'none',
                }}
              >
                <Typography.Text>
                  {formatDateTime(reservation.date)}
                </Typography.Text>
                <Typography.Text>
                  {reservation.home} - {reservation.guest}
                </Typography.Text>
                <Typography.Text>{reservation.gym}</Typography.Text>
              </Space>
            ))}
          </Descriptions.Item>
        )}
      </Descriptions>
    );
  };

  if (loading) return <Spin />;

  const carsInfo =
    carsInformation?.[teamDetails?.game_id]?.[teamDetails?.team_id];

  if (!carsInfo || carsInfo?.length === 0) return null;

  return (
    <Space direction="vertical">{carsInfo.map((car) => carData(car))}</Space>
  );
}
